<img
  class="image-workbook"
  src="assets/images/workbook-sm.png"
  alt="Image of 2 Purposeful workbooks: one open and one closed" />
<h2 class="title">You’re eligible to receive a free Purposeful Workbook!</h2>
<p class="description">
  The workbook is packed with practical tips, tools and exercises to help you uncover your purpose and bring your best
  to what matters most, each and every day.
</p>
<p class="description">
  We’ll ship it to you at no cost – and no credit card is required. Order yours while supplies last!
</p>
<div class="button-row">
  <div class="button-group">
    <a class="button button-pill button-workbook" routerLink="/welcome/workbook/review">Get My Free Workbook!</a>
    <p class="button-description">You’ll still be able to get started with Purposeful after.</p>
  </div>
  <div class="button-group" *ngIf="onboardingBloc.eligibilityCandidateStatus$ | async as candidateDataStatus">
    <a
      class="button button-pill button-secondary button-workbook"
      (click)="declineWorkbook()"
      [routerLink]="declineLink"
      [queryParams]="{ eligibilityLink: candidateDataStatus.data?.eligibilityLink || '' }">
      No Thanks
    </a>
    <p class="button-description">Continue to get started with Purposeful.</p>
  </div>
</div>
